import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'devicePipeGlobal',
})

export class DevicePipeGlobal implements PipeTransform {
  transform(value: any): any {
    if (value  === 'wheelchair') {
      return 'Wheelchair'
    } else if(value  === 'walking-stick') {
      return 'Walking-stick';
    }
    else if(value  === 'kafo') {
        return 'Knee ankle foot orthosis (KAFO)'
    }
    else if(value  === 'crutches') {
        return 'Crutches'
    }
    else if(value  === 'four-wheeled-walker') {
        return 'Four-wheeled-walker'
    }
    else if(value  === 'walking-frame') {
        return 'Walking-frame'
    }
    else if(value  === 'leg-prosthesis') {
        return 'Leg-prosthesis'
    }
    else if(value  === 'foot-brace') {
        return 'Foot-brace'
    }
    else if(value  === 'other') {
        return 'Other'
    }
  }
}